import src from "IMAGE";
export default { src, width: 279, height: 360, blurWidth: 0, blurHeight: 0};
